import React from "react";
import {IonContent, IonHeader, IonPage} from "@ionic/react";
import AppToolbar from "../../components/utils/AppToolbar";
import {WithTranslation, withTranslation} from "react-i18next";
import NoData from "../../components/utils/alert/error/NoData";

/**
 * 404 component, displayed when the route was not found
 * @author Alizée Grand
 * @version 1.0
 * @creation 16/03/2022
 * @last_update 16/03/2022
 **/
class FourOFour extends React.Component<WithTranslation> {

    render() {

        return (
            <IonPage>
                <IonHeader>
                    <AppToolbar appTitle={this.props.t("pages.no-page.title")}/>
                </IonHeader>
                <IonContent fullscreen>
                    <NoData>{this.props.t("pages.no-page.content")}</NoData>
                </IonContent>
            </IonPage>
        );

    };

}

export default withTranslation()(FourOFour);
